<template>
  <q-page class="row items-center justify-center">
    <div class="column items-center q-gutter-y-sm">
      <div class="text-h6">{{ $t('common.loading') }} ...</div>
      <q-spinner size="2rem" color="primary" />
    </div>
  </q-page>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
const store = useStore()
const route = useRoute()
const router = useRouter()

const init = async (params) => {
  const { token, target, location, baseCategory, qrCode } = params
  await store.dispatch('reporter/setToken', token)
  await store.dispatch('reporter/setReporter')
  store.dispatch('reporter/setQrCode', qrCode)
  router.push({
    path: target,
    query: { location, baseCategory }
  })
}

onMounted(async () => {
  // NOTE: we are coming from the portal APP
  const token = route.query.token
  const target = route.query.target
  const location = route.query.location
  const baseCategory = route.query.baseCategory
  const qrCode = route.query.qrCode
  await init({ token, target, location, baseCategory, qrCode })
})
</script>
